import React, { useEffect, useState } from "react";
import "./freespin_info.scss";
import useCampaigns from "../../../hooks/other/useCampaigns";
import DefaultModal from "../DefaultModal";
import FreeSpinCardGame from "../../promotions/free_spin/free_spin_card__game/FreeSpinCardGame";
import { useAppSelector } from "../../../store/index.ts";

export default function FreeSpinInfoModal({ isOpen, closeModal, campaignId }) {
  const { getCampaigns } = useCampaigns();
  const [campaign, setCampaign] = useState({});
  const isSmallDesktop = useAppSelector((state) => state.deviceSize.isSmallDesktop);

  useEffect(() => {
    if (!campaignId) return;

    getCampaigns(campaignId).then((data) => {
      setCampaign(data);
    });
  }, [campaignId]);

  const games = campaign?.games?.map((el) => ({
    id: el.gameId,
    image: el.image,
    provider: el.provider,
    name: el.name,
    freespins: el.freespins,
    bet: el.bet || {},
    wager: el.wager,
    cashout: el.cashout
  }));

  return (
    <DefaultModal
      bigModal={!isSmallDesktop}
      isOpen={isOpen}
      closeModal={closeModal}
      classModal={`freespin-info`}>
      <h3>{campaign.name}</h3>
      <div className="freespin-info__games">
        {games?.map((el) => (
          <FreeSpinCardGame key={el.id} game={el} />
        ))}
      </div>
    </DefaultModal>
  );
}
